import { React } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Styles/SVComponents.css";
import SVShowPhotoGallery from "./SVShowPhotoGallery";

function SVShowPhotosAdmin(props) {
  return (
    <>
      {props.usuario.isAdmin && (
        <>
          <Row className="mt-2">
            <Col>
              <div className="position-relative text-center">
                <h2 className="SvTitulo">Pendents validar</h2>
              </div>
            </Col>
            <hr />
            <SVShowPhotoGallery show={props.show} isValidateView={true} />
          </Row>
        </>
      )}
    </>
  );
}

export default SVShowPhotosAdmin;
